/** @jsx jsx */
import { Plural } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { jsx } from 'theme-ui';
import DefaultFacet from '../DefaultFacet/DefaultFacet';

export default function ProductCharacteristicsFacet({
  allValues,
  selectedValues,
  onToggle,
  totalCount,
  count,
  ...rest
}) {
  const { i18n } = useLingui();
  const mappedValues = allValues?.map(({ value, count }) => ({
    value,
    count,
    label: i18n._(`characteristic.${value}`),
  }));

  return (
    <DefaultFacet
      title={
        <Plural
          value={allValues?.length}
          one="# characteristic"
          other="# characteristics"
        />
      }
      allValues={mappedValues}
      selectedValues={selectedValues}
      onToggle={onToggle}
      totalCount={totalCount}
      count={count}
      {...rest}
    />
  );
}
